import fetchJsonp from "fetch-jsonp";
import { serializeObject } from '../common/util';

export const getJsonp = (options = {}) => {
    const { params, url } = options;

    if(!url) {
        console.error('호출할 api url이 존재하지 않습니다.');
        return;
    }

    const serializeParams = serializeObject(params);
    
    return fetchJsonp(`${url}${serializeParams ? `?${serializeParams}` : ''}`, {
                jsonpCallbackFunction: 'callback',
                credentials: 'include'
            })
            .then(res => res?.json());
};